import { render, staticRenderFns } from "./RefunProduct.vue?vue&type=template&id=0bcf839d&scoped=true&"
import script from "./RefunProduct.vue?vue&type=script&lang=js&"
export * from "./RefunProduct.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bcf839d",
  null
  
)

export default component.exports